export default __webpack_public_path__ + "static/media/sample_album_art.a5491cf9.png";